/**
 * Image URL utility functions
 */

/**
 * Get the backend API base URL from environment variable
 * Extracts the base URL from REACT_APP_API_URL
 * Example: https://api.nayabajar.com/graphql/ -> https://api.nayabajar.com
 */
const getBackendBaseUrl = (): string => {
  const apiUrl = process.env.REACT_APP_API_URL || 'https://api.nayabajar.com/graphql/';

  // Remove /graphql/ suffix if present
  const baseUrl = apiUrl.replace(/\/graphql\/?$/, '');

  // Remove trailing slash
  return baseUrl.replace(/\/$/, '');
};

/**
 * Convert a relative image URL to an absolute URL
 * If the URL is already absolute, returns it as-is
 * @param url - The image URL (relative or absolute)
 * @returns Absolute image URL
 */
export const getAbsoluteImageUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;

  // Already absolute (CDN, http, https) — return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  const baseUrl = getBackendBaseUrl();

  // Normalise: ensure leading slash
  const withSlash = url.startsWith('/') ? url : `/${url}`;

  // Ensure /media/ prefix for Django media files
  const withMedia = withSlash.startsWith('/media/') ? withSlash : `/media${withSlash}`;

  return `${baseUrl}${withMedia}`;
};

/**
 * Get a placeholder image URL with fallback
 * @param customPlaceholder - Custom placeholder URL
 * @returns Placeholder image URL
 */
export const getPlaceholderImage = (customPlaceholder?: string): string => {
  return customPlaceholder || '/placeholder-ad.png';
};
